export const SORT_TYPES = {
  RELEVANCE: "relevant",
  NEWEST: "newest",
  OLDEST: "oldest",
  NONE: "none"
};

export const getEffectiveSort = (sortType, hasSearchOrFilters) => {
  if (sortType === SORT_TYPES.NEWEST) return "NEWEST";
  if (sortType === SORT_TYPES.OLDEST) return "OLDEST";
  if (sortType === SORT_TYPES.NONE) return "NONE";
  if (sortType === SORT_TYPES.RELEVANCE) {
    return hasSearchOrFilters ? "RELEVANCE" : "NONE";
  }
  return "NONE";
};

export const applyPlaylistTrackOrder = (tracks, trackOrder) => {
  if (!Array.isArray(trackOrder) || trackOrder.length === 0) return tracks;

  const byPlaylistTrackId = new Map();
  tracks.forEach(item => {
    const id = item.track.playlistTrackId;
    if (id != null) byPlaylistTrackId.set(id, item);
  });

  const ordered = [];
  const usedIds = new Set();
  trackOrder.forEach(id => {
    const item = byPlaylistTrackId.get(id);
    if (item) {
      ordered.push(item);
      usedIds.add(id);
    }
  });

  // append any tracks not in trackOrder (defensive — newly added tracks)
  tracks.forEach(item => {
    const id = item.track.playlistTrackId;
    if (id == null || !usedIds.has(id)) ordered.push(item);
  });

  return ordered;
};
